export default __webpack_public_path__ + "static/Commissioner-a943e86dd44d1055479ba07653d3e98d.ttf";